import apiServiceCall from "../services/ApiServiceCall";

export const getGeneralInformations = () => {
  return apiServiceCall().get('/vui/frontend/general-info').then(({ data }) => data);
}

// Alias para compatibilidad con código existente
export const getGeneralInformationsFromWordpress = getGeneralInformations;

export const getAllServices = () => {
  return apiServiceCall().get('/services').then(({ data }) => data);
}

export const getAllQuestions = () => {
  return apiServiceCall().get('/vui/frontend/faqs').then(({ data }) => data);
}

